// extracted by mini-css-extract-plugin
export default {"container":"CancelOrder_container__hjITv","title":"CancelOrder_title__bASNH","post":"CancelOrder_post__V0z0h","button":"CancelOrder_button__KScUX"};